import _styled from "styled-components";
import { getThemeStyle } from "~/features/ui/get-theme-style";
type Props = {
  children: React.ReactNode;
};
export function TableCell(props: Props & React.ComponentPropsWithRef<"div">) {
  const {
    children,
    ...rest
  } = props;
  const themeStyle = getThemeStyle({
    mode: "light"
  });
  return <_StyledDiv {...rest} $_css={[{
    "display": "flex",
    "flex": "1 1 0%",
    "flexWrap": "wrap",
    "alignItems": "center",
    "gap": "1.6rem",
    "paddingLeft": "2.4rem",
    "paddingRight": "2.4rem",
    "paddingTop": "0.8rem",
    "paddingBottom": "0.8rem",
    "fontSize": "1.6rem",
    "lineHeight": "1.5",
    "fontWeight": "400",
    "@media (min-width: 1024px)": {
      "flexShrink": "0",
      "justifyContent": "center",
      "whiteSpace": "nowrap",
      "borderBottomWidth": "0px",
      "borderTopWidth": "1px",
      "fontSize": "1.4rem",
      "lineHeight": "1.5",
      "letterSpacing": "0.014000000000000002rem",
      "fontWeight": "400",
      "&:not(:last-child)": {
        "borderRightWidth": "1px"
      }
    }
  }, themeStyle.border]}>
      {children}
    </_StyledDiv>;
}
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "table-cell___StyledDiv",
  componentId: "sc-1j01kdm-0"
})(["", ""], p => p.$_css);